var _rect, _rect2, _rect3, _rect4, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.933008,
    y: 0.6,
    width: 70,
    height: 70,
    rx: 35,
    stroke: "url(#paint0_linear_706_71236)",
    strokeWidth: 1.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.933008,
    y: 0.6,
    width: 70,
    height: 70,
    rx: 35,
    stroke: "url(#paint1_linear_706_71236)",
    strokeWidth: 1.2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10.5326,
    y: 10.1996,
    width: 50.8,
    height: 50.8,
    rx: 25.4,
    stroke: "url(#paint2_linear_706_71236)",
    strokeWidth: 1.2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 10.5326,
    y: 10.1996,
    width: 50.8,
    height: 50.8,
    rx: 25.4,
    stroke: "url(#paint3_linear_706_71236)",
    strokeWidth: 1.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_706_71236)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.832 23.7696C45.5116 23.4492 44.9923 23.4493 44.6719 23.7696C44.3516 24.0899 44.3516 24.6093 44.6719 24.9297C47.0064 27.264 48.292 30.3677 48.292 33.6691C48.292 34.1221 48.6593 34.4894 49.1123 34.4894C49.5654 34.4894 49.9326 34.1221 49.9326 33.6691C49.9326 29.9295 48.4763 26.4138 45.832 23.7696Z",
    fill: "#009DDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1932 23.7696C26.8728 23.4492 26.3534 23.4493 26.033 23.7696C23.3889 26.4139 21.9326 29.9296 21.9326 33.669C21.9326 34.1221 22.2999 34.4894 22.7529 34.4894C23.206 34.4894 23.5732 34.1221 23.5732 33.669C23.5732 30.3678 24.8588 27.2641 27.1932 24.9297C27.5135 24.6093 27.5135 24.0899 27.1932 23.7696Z",
    fill: "#009DDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1865 26.2549C41.8662 26.5753 41.8662 27.0946 42.1866 27.415C43.8573 29.0856 44.7773 31.3068 44.7773 33.6695C44.7773 34.1225 45.1447 34.4898 45.5976 34.4898C46.0507 34.4898 46.418 34.1225 46.418 33.6695C46.418 30.8685 45.3272 28.2353 43.3467 26.2548C43.0263 25.9345 42.5069 25.9346 42.1865 26.2549Z",
    fill: "#009DDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6783 26.2548C29.358 25.9345 28.8386 25.9346 28.5182 26.2549C26.5379 28.2355 25.4473 30.8685 25.4473 33.6691C25.4473 34.1221 25.8146 34.4894 26.2676 34.4894C26.7207 34.4894 27.0879 34.1221 27.0879 33.6691C27.0879 31.3067 28.0079 29.0856 29.6784 27.415C29.9987 27.0946 29.9987 26.5752 29.6783 26.2548Z",
    fill: "#009DDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.903 39.626V35.4264C42.903 33.8946 42.4153 32.441 41.4927 31.2229C40.7215 30.2048 39.6698 29.4094 38.4882 28.9414C38.3237 27.6775 37.2402 26.6982 35.9322 26.6982C34.6242 26.6982 33.5406 27.6775 33.3761 28.9414C32.1946 29.4094 31.1429 30.2048 30.3717 31.2229C29.449 32.441 28.9613 33.8946 28.9613 35.4264V39.626L27.2907 42.9673C27.1636 43.2216 27.1771 43.5236 27.3266 43.7654C27.476 44.0073 27.7401 44.1545 28.0244 44.1545H43.84C44.1243 44.1545 44.3883 44.0073 44.5378 43.7654C44.6873 43.5236 44.7009 43.2216 44.5737 42.9673L42.903 39.626Z",
    fill: "#009DDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9331 47.669C37.4099 47.669 38.7159 46.9261 39.4989 45.7949H32.3672C33.1503 46.9261 34.4563 47.669 35.9331 47.669Z",
    fill: "#009DDD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_706_71236",
    x1: 6.19398,
    y1: 75.1073,
    x2: 74.7891,
    y2: -4.77561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009DDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.323723,
    stopColor: "#009DDD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_706_71236",
    x1: 71.3159,
    y1: -9.11707,
    x2: 6.19398,
    y2: 71.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009DDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.576615,
    stopColor: "#009DDD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_706_71236",
    x1: 4.27133,
    y1: 12.5351,
    x2: 61.7229,
    y2: 61.5996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009DDD",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.323723,
    stopColor: "#009DDD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_706_71236",
    x1: 72.2068,
    y1: 73.3415,
    x2: 11.8197,
    y2: 30.5673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009DDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.576615,
    stopColor: "#009DDD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_706_71236"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(21.9326 21.5996)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationAlert);
export default __webpack_public_path__ + "static/media/NotificationAlert.95911a7ae6ff8e5b9bea899d8059adb2.svg";
export { ForwardRef as ReactComponent };